export const recieve_events = {
  CHECK_UPDATE: 'CHECK_UPDATE',
  MINIMZE_MAIN_WINDOW: 'MINIMZE_MAIN_WINDOW',
  MAXIMIZE_MAIN_WINDOW: 'MAXIMIZE_MAIN_WINDOW',
  UNMAXIMIZE_MAIN_WINDOW: 'UNMAXIMIZE_MAIN_WINDOW',
  CLOSE_MAIN_WINDOW: 'CLOSE_MAIN_WINDOW',
}